

export const Restaurant = ({ selLanguage }) => {
    return (
        <>
            <div>
                {selLanguage === "en" ?

                    <>
                        <h1>“Block” restaurant </h1>
                        <p>
                            Alexander Rappoport’s “Block” restaurant occupies the roof of Leningrad Centre and offers guests a panoramic view of Tauride Garden. This is a place where gastronomy meets art: the interior is designed in the aesthetic style of Northern Modernism and the Leningrad avant-garde. A bright, multi-level space, chandelier installations and multimedia canvases – you’ll want to linger here both before and after the show.
                        </p>
                        <p>
                            The cuisine is based on a modern interpretation of Russian gastronomic traditions. The star of the menu is top-quality domestic meat, which is now rightly considered one of the best in the world. During the warmer months, two terraces overlooking the garden are open. The interiors are filled with light, air and an endless festive atmosphere.
                        </p>
                    </>
                    :
                    <>
                        <h1>Ресторан «Блок»</h1>
                        <p>
                            Ресторан «Блок» Александра Раппопорта занимает крышу Ленинград Центра и открывает гостям панорамный вид на Таврический сад. Это место, где гастрономия встречается с искусством: интерьер выполнен в эстетике северного модерна и ленинградского авангарда. Светлое многоуровневое пространство, инсталляции из люстр и мультимедийные полотна — здесь хочется задержаться и после шоу, и до него.
                        </p>
                        <p>
                            В основе кухни — современное прочтение российской гастрономической традиции. Главный герой меню — отечественное мясо высшего сорта, которое сегодня по праву считается одним из лучших в мире. В теплое время года открыты две террасы с видом на сад. В интерьерах — свет, воздух и ощущение праздника, которое здесь вообще не принято прерывать.
                        </p>
                    </>
                }
                <p><strong>Телефон: </strong><span>8 (812) 415-40-40</span></p>
                <p><a href="https://blok.restaurant/" target="_blank">https://blok.restaurant/</a></p>
                <p className="text-muted" style={{ fontSize: "8px" }}>erid: 2SDnjeawXAg</p>
            </div>
        </>
    )
}